import { Box, Fab, Skeleton, Stack, Typography } from "@mui/material";

import { Calendar } from "../../assets";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import { styled } from "@mui/material/styles";

export const PaddedContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
}));

export const HeaderStack = styled(Stack)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export const HeaderText = styled(Typography)(() => ({
  width: "90%",
}));

export const ScrollContainer = styled(Box)(() => ({
  flexGrow: 1,
  paddingTop: 4,
}));

export const AllEventsText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  display: "flex"
}));

export const InfiniteScrollEndContainer = styled(Box)(() => ({
  textAlign: "center",
  marginTop: 32,
}));

export const RefreshEventsContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "row-reverse",
  width: "10%",
}));

export const SkeletonCardContainer = styled(Box)(() => ({
  width: "100%",
  height: "354px",
}));

export const SkeletonCardDescription = styled(Skeleton)(() => ({
  borderBottomLeftRadius: 12,
  borderBottomRightRadius: 12,
  width: "100%",
  height: "100px",
}));

export const SkeletonCardImage = styled(Skeleton)(() => ({
  borderTopLeftRadius: 12,
  borderTopRightRadius: 12,
  width: "100%",
  height: "200px",
}));

export const SkeletonCardText = styled(Skeleton)(() => ({
  width: "100%",
  height: "40px",
}));

export const SubtitleContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const SubtitleContainerSkeleton = styled(Skeleton)(({ theme }) => ({
  height: "56px",
  width: "100%",
  marginBottom: theme.spacing(3),
}));

export const SubtitleActionContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.up("tablet")]: {
    width: "50%",
    flexDirection: "row-reverse",
    marginBottom: 0,
  },
  [theme.breakpoints.up("desktop")]: {
    width: "50%",
    flexDirection: "row-reverse",
    marginBottom: 0,
  },
}));

export const SubtitleTitle = styled(Typography)(({ theme }) => ({
  width: "100%",
  [theme.breakpoints.up("tablet")]: {
    width: "50%",
    marginBottom: 0,
  },
  [theme.breakpoints.up("tablet")]: {
    width: "50%",
    marginBottom: 0,
  },
}));

export const SubtitleActionText = styled(Typography)(({ theme }) => ({
  cursor: "pointer",
  transition: "opacity 0.3s ease",
  "&:hover": {
    opacity: 0.7,
  },
  color: theme.colors.primary.slalomDarkBlue,
}));

export const SubtitleStackContainer = styled(Stack)(({ theme }) => ({
  width: "100%",
  marginBottom: theme.spacing(2),
}));

export const SubtitleText = styled(Typography)(({ theme }) => ({
  color: theme.colors.neutral.darkGray,
}));

export const ScrollToTopFab = styled(Fab)(({ theme }) => ({
  position: "fixed",
  bottom: 30,
  left: "50%",
  marginLeft: "-52.55px",
  boxShadow: `0px 6px 6px 0px ${theme.colors.action.hoverShadow}`,
}));

export const NoUpcomingEventsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(8),
  textAlign: "center",
  width: "100%",
}));

export const NoUpcomingEventsText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const CalendarIcon = styled(Calendar)(({ theme }) => ({
  width: "20vh",
  height: "auto",
  marginBottom: theme.spacing(2),
}));

export const SortFilterIcon = styled(FilterListOutlinedIcon)(({ theme }) => ({
  fill: theme.colors.primary.slalomDarkBlue,
  marginRight: theme.spacing(1),
}));

export const SortAndFilterTextContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  marginBottom: theme.spacing(2),
}));

export const ClearAllTextContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  marginBottom: theme.spacing(2),
}));

export const FilterPillClearAllTextContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: theme.spacing(2),
}));

export const ClearAllButton = styled(Typography)(({ theme }) => ({
  cursor: "pointer",
  transition: "opacity 0.3s ease",
  color: theme.colors.primary.slalomDarkBlue,
  "&:hover": {
    opacity: 0.7,
  },
  display: "flex", 
  alignItems: "center", 
}));
